export default function idArgSelector(state, idArg) {
    return idArg;
}
